import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Button, Paper, Typography, Tooltip, Menu, MenuItem, Grid,Modal, Select, Divider, Stack, Card, CardContent, Collapse, Skeleton, CircularProgress} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Tree, TreeNode } from 'react-organizational-chart';
import SimpleOrgChart from '../components/TeamBoard';
import IconButton from '@mui/material/IconButton';
import WalletIcon from "../assets/dashboad/Wallet.svg"
import PlusIcon from "../assets/dashboad/Vector.svg"
import SalaryIcon from "../assets/dashboad/Salary.svg"
import AtmIcon  from "../assets/dashboad/Atm.svg"
import ThreeDotIcon from "../assets/dashboad/Threedot.svg"
import RecievedIcon from "../assets/dashboad/Received.svg"
import OrgIcon from "../assets/dashboad/Organization chart.svg"
import MeetIcon from "../assets/dashboad/Meeting.svg"
import InfoIcon from "../assets/dashboad/info.svg"
import WageIcon from "../assets/dashboad/Wage.svg"
import AmbIcon from "../assets/dashboad/Ripple.svg"
import GoldAmbIcon from "../assets/dashboad/Gold.svg"
import DiaIcon from "../assets/dashboad/Diamond.svg"
import CrownIcon from "../assets/dashboad/Crown.svg"
import LinkIcon from '@mui/icons-material/Link';
import Layout from "../layout"
import SideBarList from "../components/list"
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector, useStore } from "react-redux"
import { useEffect, useRef, useState } from "react"
import CustomAxios from '../utils/CustomAxios';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import React from 'react';
import Avatar from '@mui/material/Avatar';
import { Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    ArcElement,
    Tooltip as Ctooltip,
    Legend,
    BarElement,
    RadialLinearScale} from 'chart.js'
import { TranslateText } from "../utils/googletranslator"; 
import { Bar,Line } from 'react-chartjs-2';
import { updateSnackBarMessage, updateSnackBarOpen, updateSnackBarSeverity } from "../redux/snackbar";
import MessageBar from "../modules/messageBar";
import { updateAddressModal, updateUserName, updateBio, updateAddress,updateEmail,updateMobile,updateProfile, updateOtpCheck,updateGetBank,updateWithdrawRequest,updateWhatsapp, updateMembership, updateIsProfileReloaded,  updateMemberResponse,updateMultiple, updateMultipleAccount, updateSwitchedAccount, updateAccumulated } from "../redux/user_reducer"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Info,ChevronLeft, ChevronRight, } from "@mui/icons-material";
import { updateOrdersAndLevels } from "../redux/products";
import GoalStatus from "../components/goal";
ChartJS.register(
    BarElement,
    RadialLinearScale,
    ArcElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Ctooltip,
    Legend
);
const Dashboard = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isLaptop = useMediaQuery({ query: '(min-width: 900px)' });
    const isXLaptop = useMediaQuery({ query: '(min-width: 1600px)' });
    const isTabletHori = useMediaQuery({ query: '(min-width: 1200px)' });
    const isTablet= useMediaQuery({ maxWidth: 900,minWidth:600 });
    const isProfileReloaded=useSelector(state=>state.user.isProfileReloaded)
    const transferReferalClose=useSelector(state=>state.user.tranferReferralclose) 
    const [open, setOpen] =useState(false);
    const [imageurl, setImageUrl] = useState('')
    const [userreponse, setUserResponse] = useState({})
    const [city, setCity] = useState('')
    const [packagedetails, setPackageDetails] = useState([])
    const [country, setCountry] = useState('')
    const dispatch = useDispatch()
    const reduxStore = useStore()
    let id = parseInt(useSelector(state => state.user.id))
    const resolvedUserId = Number.isFinite(id) && id > 0 ? id : null
    let profile = useSelector(state => state.user.profile)
    let res = useSelector(state => state.user.member_response)
    let commissions = useSelector(state => state.product?.OrdersAndLevels)
    const [team_member,setTeamMemeber]=useState([])
    const [subMember,setSubMember]=useState()
    const [teamGrowth,setTeamGrowth]=useState()
    const [teamChart,setTeamChart]=useState()
    const [teamInsights, setTeamInsights] = useState(null)
    const [commissionChart,setCommissionChart]=useState()
    const [data, setData] = useState({ labels: [], datasets: [] });
    const [treeBoard,setTreeBoard]=useState([])
    const [treeMetrics, setTreeMetrics] = useState({ totalMembers: 0, maxDepth: 0 })
    const [isTreeLoading, setIsTreeLoading] = useState(true)
    const [treeLoadError, setTreeLoadError] = useState("")
    const [imagestatus,setImageStatus]=useState(true)
    const [secondLevel,setSecondLevel]=useState(true)
    const [restrictClose,setRestrictClose]=useState(false)
    const [isTreeExpanded, setIsTreeExpanded] = useState(false)
    const [expandedNodes, setExpandedNodes] = useState(new Set([0])) // Root node expanded by default
    const [selectedLevel, setSelectedLevel] = useState(0)
    // // console.log(res)
    // const [performance,]
    const [teamPerformance,setTeamPerformance]=useState()
    const [loopCall,setLoopCall]=useState(true)
    const [performanceChart,setPerformanceChart]=useState()
    const formStyle = {
        inputBase: { border: "1px solid", borderColor: "grey.400", width: "100%", borderRadius: "5px", height: "48px", fontSize: "16px", padding: "14px", color: "grey.700" },
        label: { marginBottom: "12px", fontWeight: 700, fontSize: "16px" },
        textBox: { border: "1px solid", borderColor: "grey.400", width: "100%", borderRadius: "5px", fontSize: "16px", padding: "14px", color: "grey.700" },
        button: { marginBottom:"5px", textTransform: "none", marginTop:isLaptop?"24px":"0px", marginRight:isLaptop?"20px":"0px", borderRadius:"5px",fontWeight: 600, fontSize: "14px", maxWidth: "300px", alignSelf:isLaptop?"flex-end":"", marginTop:isLaptop?"":"15px" },
    }
    let  first_name = useSelector(state => state.user.first_name)
    let  last_name = useSelector(state => state.user.last_name)
    const packagesRef = useRef(null)
    const [activeSlide, setActiveSlide] = useState(0);
    let sliderRef = useRef(null);

    const [isMCTransferClicked,setIsMCTransferClicked] = useState(false)
    const [isMETransferClicked,setIsMETransferClicked] = useState(false)
    const [ReUsername,setRecUsername] = useState(null)
    const [Transferamt,setTransferAmt] = useState(0.00)
    const [transferModalOpen,setTransferModalOpen] = useState(false)
    const [transferReferalModal,setTransferReferalModal] = useState(false)
    const [netWorthData, setNetWorthData] = useState(null)
    const [useSimpleTree, setUseSimpleTree] = useState(true) // Temporary toggle for debugging
    const showTeamInsights = false
    const resolvedTotalMembers = Number.isFinite(Number(userreponse?.team_size))
        ? Number(userreponse?.team_size)
        : treeMetrics.totalMembers
    // dashboard-details/ returns direct_members_count (lvl1 referrals); fallback for older payloads
    const resolvedDirectMembers = Number.isFinite(Number(userreponse?.direct_members_count))
        ? Number(userreponse.direct_members_count)
        : Array.isArray(userreponse?.team_member)
          ? userreponse.team_member.length
          : 0
    const resolvedTeamLevel = Number.isFinite(Number(userreponse?.level))
        ? Math.min(Number(userreponse?.level), 9)
        : treeMetrics.maxDepth
    const hasOverviewData = Boolean(userreponse?.user)
    const hasInsightsData = Boolean(teamInsights)
    const isDetailsLoading = useSelector(state=>state.user.isDetailsLoading)

    // dashboard-details/ omits pv + package_details; get_details/ may still provide pv for rank badges.
    const pvRankAmount =
        userreponse?.pv != null && userreponse?.pv !== ""
            ? Number(userreponse.pv) / 0.6
            : NaN
    const showPvRankIcons = Number.isFinite(pvRankAmount)
    const walletBalanceDisplay =
        userreponse?.mc?.balance != null ? Number(userreponse.mc.balance) || 0 : null
    const withdrawalAvailableDisplay =
        userreponse?.accumulated?.withdrawal_available != null
            ? Number(userreponse.accumulated.withdrawal_available) || 0
            : null
    const netWorthTotal =
        walletBalanceDisplay != null && withdrawalAvailableDisplay != null
            ? walletBalanceDisplay + withdrawalAvailableDisplay
            : null
    const canShowNetWorth = netWorthTotal != null

    const packageSliderSettings = {
        infinite : false,
        
        slidesToScroll : isTablet ? 1 :isTabletHori? 1 : isLaptop ? 2 : isXLaptop? 3 : 5 ,
        slidesToShow : isTablet ? 1 : isTabletHori? 1 :isLaptop ? 2 : isXLaptop ? 3 : 5 ,   
        // slidesToShow : isTablet ? 1 : isLaptop ? 2 : isXLaptop? 3 : 5,
        variableWidth : true,
        swipe:true,
        tochMove:true,
        swipeToSlide:true,
        afterChange: (slide) => setActiveSlide(slide),
        

    }
    useEffect(()=>{
        setUserResponse(res)
    },[res])

    useEffect(()=>{
        setPackageDetails(userreponse?.package_details ?? [])
    }
,[userreponse])
useEffect(()=>{
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

},[])
useEffect(()=>{
    // console.log(userreponse,Object.keys(userreponse).length)
        if (
            Object.keys(userreponse).length>0 &&
            userreponse?.user &&
            Array.isArray(userreponse?.team_member)
        ){
        let user_tree={member:{},members:[],team_count:0}
        user_tree.member=userreponse?.user
        user_tree.team_count=userreponse?.team_size
        user_tree.direct_members_count =
            userreponse?.direct_members_count != null && userreponse?.direct_members_count !== ""
                ? Number(userreponse.direct_members_count)
                : undefined
        // Map through transformTeamBoardData so lvl2 from dashboard-details (lvl2_members) becomes
        // nested child/children on lvl1 nodes — same shape as get_details + transform path.
        const transformed = transformTeamBoardData(userreponse)
        const main = transformed?.[0]
        user_tree.members = main?.children ?? main?.child ?? userreponse.team_member ?? []
        //    console.log(user_tree)
           setTreeBoard([user_tree])
            // setTeamMemeber(userreponse.team_member)
        }
   
// user_tree['']


},[userreponse])

    // useEffect(() => {
    //     if (!resolvedUserId) {
    //         setNetWorthData(null)
    //         return
    //     }
    //     let cancelled = false
    //     CustomAxios.post("net-worth/", { user_id: resolvedUserId })
    //         .then((r) => {
    //             if (cancelled) return
    //             if (r.data?.success) {
    //                 setNetWorthData(r.data)
    //                 const prevAcc = reduxStore.getState().user.accumulated ?? {}
    //                 const wb = Number(r.data.wallet_balance) || 0
    //                 const wa = Number(r.data.withdrawal_available) || 0
    //                 dispatch(
    //                     updateAccumulated({
    //                         ...prevAcc,
    //                         withdrawal_available: wa,
    //                     })
    //                 )
    //                 const memberRes = reduxStore.getState().user.member_response ?? {}
    //                 dispatch(
    //                     updateMemberResponse({
    //                         ...memberRes,
    //                         mc: { ...(memberRes.mc || {}), balance: wb },
    //                         commission_history: r.data?.commission_history ?? memberRes.commission_history,
    //                     })
    //                 )
    //             } else {
    //                 setNetWorthData({ success: false })
    //             }
    //         })
    //         .catch(() => {
    //             if (!cancelled) setNetWorthData({ success: false })
    //         })
    //     return () => {
    //         cancelled = true
    //     }
    // }, [resolvedUserId])

    useEffect(() => {
        if (!resolvedUserId){
            setIsTreeLoading(false)
            setTreeLoadError("")
            return
        }

        if (Object.keys(userreponse || {}).length > 0){
            setIsTreeLoading(false)
            setTreeLoadError("")
            return
        }

        setIsTreeLoading(true)
        setTreeLoadError("")

        const timeoutId = setTimeout(() => {
            setIsTreeLoading(false)
            setTreeLoadError("Team data is taking longer than expected. Please refresh.")
        }, 15000)

        return () => clearTimeout(timeoutId)
    }, [resolvedUserId, userreponse])
    const package_details=[{
        package_type:"Package D",
        package_amount:"1120",
        package_status:"Incomplete",
        package_remaining_amount:"1120"
    },
    {
        package_type:"Package C",
        package_amount:"3360",
        package_status:"Incomplete",
        package_remaining_amount:"3360"
    },
    {
        package_type:"Package B",
        package_amount:"11200",
        package_status:"Incomplete",
        package_remaining_amount:"11200"
    },
    {
        package_type:"Package A",
        package_amount:"56000",
        package_status:"Incomplete",
        package_remaining_amount:"56000"
    },
    {
        package_type:"Package AA",
        package_amount:"112000",
        package_status:"Incomplete",
        package_remaining_amount:"112000"
    },
]

    const fetchTeamBoardData = async (userid) => {
        try {
            // For now, let's use the existing get_details API and transform it
            // Later we can optimize to use the new team_board API
            const response = await CustomAxios.post(`get_details/`, {
                user_id: userid 
            });
            console.log("response.data in fetchTeamBoardData.js",response.data)
            if (response.data) {
                // Transform the existing API response to work with SimpleOrgChart
                const transformedData = transformTeamBoardData(response.data);
                setTreeBoard(transformedData);
                setTeamMemeber(response.data.team_member || []);
            }
        } catch (error) {
            console.error('Error fetching team board data:', error);
            // Fallback to old method if new API fails
            setTreeBoard([]);
            setTeamMemeber([]);
        }
    }

    // Function to fetch children for dynamic loading
    const fetchChildrenData = async (userId) => {
        // console.log("????????userId",userId)
        try {
            const response = await CustomAxios.get(`team_board/`, {
                params: {
                    user_id: userId,
                    level: 0,
                    max_depth: 2,
                    page: 1,
                    page_size: 20
                }
            });

            if (response.data.success) {
                const children = response.data.data.children || [];
                // console.log("????????response",response)
                // Transform children to match the expected format
                return children.map(child => ({
                    id: child.id,
                    first_name: child.first_name,
                    last_name: child.last_name,
                    email: child.email,
                    mobileno: child.mobileno,
                    referral_code: child.referral_code,
                    created_on: child.created_on,
                    account: child.account,
                    customAccount: child.customAccount,
                    child: [], // Initially empty, will be fetched when clicked
                    children: [], // Initially empty, will be fetched when clicked
                    team_stats: {
                        total_team_members: child.team_count || 0
                    },
                    child_stats: {
                        member_count: child.direct_members_count || 0
                    }
                }));
            }
        } catch (error) {
            console.error('Error fetching children for user:', userId, error);
        }
        return [];
    }

    const transformTeamBoardData = (apiData) => {
        // Transform the get_details API response to work with SimpleOrgChart
        if (!apiData) return [];
        // Expect dashboard-details/get_details style payload: apiData.user + apiData.team_member[]
        if (!apiData.user || !apiData.user.id) return [];

        const transformNode = (node) => {
            if (!node) return null;

            return {
                id: node.id || node.user__id,
                first_name: node.first_name || node.user__first_name,
                last_name: node.last_name || node.user__last_name,
                email: node.email || node.user__email,
                mobileno: node.user__mobileno || node.mobileno,  // Prioritize CustomUser mobile
                referral_code: node.referral_code,
                created_on: node.created_on || node.user__date_joined,
                account: {
                    id: node.id,
                    user: node.user__id,
                    referral_code: node.referral_code,
                    mobileno: node.user__mobileno || node.mobileno,  // Use CustomUser mobile
                    created_on: node.created_on,
                },
                customAccount: {
                    id: node.id,
                    user: node.user__id,
                    referral_code: node.referral_code,
                    mobileno: node.user__mobileno || node.mobileno,  // Use CustomUser mobile
                    created_on: node.created_on,
                },
                child: [], // Will be populated dynamically
                children: [], // Will be populated dynamically
                team_stats: {
                    total_team_members: 0 // Will be calculated when needed
                },
                child_stats: {
                    member_count: 0 // Will be calculated when needed
                }
            };
        };

        // Transform team members from the API response (lvl1). Dashboard API may include
        // `lvl2_members` per row so the tree can show two levels without lazy `team_board/` calls.
        const teamMembers = (apiData.team_member || []).map((member) => {
            const lvl1Node = transformNode({
                id: member.user__id,
                user__id: member.user__id,
                user__first_name: member.user__first_name,
                user__last_name: member.user__last_name,
                user__email: member.user__email,
                user__date_joined: member.user__date_joined,
                user__mobileno: member.user__mobileno,
                mobileno: member.mobileno,
                referral_code: member.referral_code,
                created_on: member.created_on,
            })
            const lvl2Raw = member.lvl2_members || []
            const lvl2Nodes = lvl2Raw.map((row) =>
                transformNode({
                    id: row.user__id,
                    user__id: row.user__id,
                    user__first_name: row.user__first_name,
                    user__last_name: row.user__last_name,
                    user__email: row.user__email,
                    user__date_joined: row.user__date_joined,
                    user__mobileno: row.user__mobileno,
                    mobileno: row.mobileno,
                    referral_code: row.referral_code,
                    created_on: row.created_on,
                })
            )
            const hasLvl2 = lvl2Nodes.length > 0
            const apiDirect =
                member.direct_members_count != null && member.direct_members_count !== ""
                    ? Number(member.direct_members_count)
                    : NaN
            const directCount = Number.isFinite(apiDirect) ? apiDirect : hasLvl2 ? lvl2Nodes.length : 0
            return {
                ...lvl1Node,
                child: lvl2Nodes,
                children: lvl2Nodes,
                direct_members_count: directCount,
                team_stats: {
                    ...lvl1Node.team_stats,
                },
                child_stats: {
                    member_count: directCount,
                },
                has_more_children: Boolean(
                    member.has_more_children || member.has_more_lvl2
                ),
            }
        })

        // Transform the main user data
        const mainUser = {
            id: apiData.user.id,
            first_name: apiData.user.first_name,
            last_name: apiData.user.last_name,
            email: apiData.user.email,
            mobileno: apiData.user.mobileno || apiData.account?.mobileno,  // Use CustomUser mobile first
            referral_code: apiData.account?.referral_code,
            created_on: apiData.user.date_joined,
            account: apiData.account,
            customAccount: apiData.account,
            child: teamMembers, // Use the transformed team members
            children: teamMembers, // Use the transformed team members
            team_stats: {
                total_team_members: apiData.team_size || teamMembers.length
            },
            child_stats: {
                member_count: apiData.team_size || teamMembers.length
            }
        };

        return [mainUser];
    }
    const capitalize = (str) => {
        return str?.split(' ').map(word => word?.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      };

      const formatdate = (date) => {
        const newdate = new Date(date);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[newdate.getMonth()];
        const year = newdate.getFullYear()
        const formatdate =newdate.getDate()+" " + month + " " + year
        return formatdate
    }
    const handleCopyurl = () =>{
        const referralCode = String(userreponse?.account?.referral_code || "").trim()

        if (!referralCode || ["undefined", "null"].includes(referralCode.toLowerCase())) {
            dispatch(updateSnackBarMessage("Referral link is not available yet"))
            dispatch(updateSnackBarSeverity("error"))
            dispatch(updateSnackBarOpen(true))
            return
        }

        const url = process.env.REACT_APP_URL+`signup/?code=${referralCode}`
        navigator.clipboard.writeText(url)
        .then(() => {
            dispatch(updateSnackBarMessage("URL copied to clipboard!"))
            dispatch(updateSnackBarSeverity("success"))
          })
          .catch((error) => {
            dispatch(updateSnackBarMessage(error))
            dispatch(updateSnackBarSeverity("error"))
          });
          dispatch(updateSnackBarOpen(true))
    }
    const handleClose = () => {
        dispatch(updateAddressModal(false))
        setOpen(false);
    };
    const addCurrencyAndCommafy = (num) => {
        // // console.log(num)

        let str = parseFloat(num).toFixed(2).toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        return "$" + str.join('.');

    }

    const calculateWidth = (detail) =>{
        let width

        if (parseFloat(detail.package_remaining_amount)>0 && parseFloat(detail.package_remaining_amount)<=parseFloat(detail.package_amount)){
        const widthcal = parseInt(detail.package_amount)-parseInt(detail.package_remaining_amount)
        width = (315/detail.package_amount) * widthcal + "px"}
        else{
        width = "315px"
        }
        return width  
    }

    const calculatePV = (detail) => {
        //const avlamt = parseInt(detail.package_amount)-parseInt(detail.package_remaining_amount)
        const calculatedpv = parseFloat(detail.commision_amount) * 0.6
        return "(" + calculatedpv.toFixed(2) + "PV" + ")"
    }

    

    const getMemberLevel = (pv, type) =>{
        // // console.log(pv)
        let memberLevel, memberPercent, memberremamt, memberremwidth, memprevlevel
        if (parseFloat(pv)<89000.00){
            memberLevel="Member"
            memberPercent=(parseFloat(pv)/89000.00) * 100
            memberremamt=89000.00 - parseFloat(pv)
            memberremwidth = (348/89000.0) * parseFloat(pv) + "px"
            memprevlevel="Ambassador"
        }
        if (parseFloat(pv)>=89000.00&&parseFloat(pv)<178000.00){
            // console.log("here")
                memberLevel="Ambassador"
                memberPercent = (parseFloat(pv)/178000.00) * 100
                memberremamt=178000.00 - parseFloat(pv)
                memberremwidth = (348/178000.0) * parseFloat(pv) + "px"
                memprevlevel="Gold Ambassador"
        }
        if (parseFloat(pv)>=178000.00&&parseFloat(pv)<355000.00){
            memberLevel="Gold Ambassador"
            memberPercent = (parseFloat(pv)/355000.00) * 100
            memberremamt=355000.00 - parseFloat(pv)
            memberremwidth = (348/355000.0) * parseFloat(pv) + "px"
            memprevlevel="Double Ambassador"
            
        }
        if (parseFloat(pv)>=355000.00&&parseFloat(pv)<709000.00){
            memberLevel="Double Ambassador"
            memberPercent = (parseFloat(pv)/709000.00) * 100
            memberremamt=709000.00 - parseFloat(pv)
            memberremwidth = (348/709000.0) * parseFloat(pv) + "px"
            memprevlevel="Diamond Ambassador"
        }
        if (parseFloat(pv)>=709000.00&&parseFloat(pv)<900000.00){
            memberLevel="Diamond Ambassador"
            memberPercent = (parseFloat(pv)/900000.00) * 100
            memberremamt=900000.00 - parseFloat(pv)
            memberremwidth = (348/709000.0) * parseFloat(pv) + "px"
            memprevlevel="Double Diamond Ambassador"
        }
        if (parseFloat(pv)>=900000.00&&parseFloat(pv)<1770000.00){
            memberLevel="Double Diamond Ambassador"
            memberPercent = (parseFloat(pv)/1770000.00) * 100
            memberremamt=1770000.00 - parseFloat(pv)
            memberremwidth = (348/1770000.0) * parseFloat(pv) + "px"
            memprevlevel="Crown Ambassador"
        }
        if (parseFloat(pv)>=1770000.00&&parseFloat(pv)<3542000.00){
            memberLevel="Crown Ambassador"
            memberPercent = (parseFloat(pv)/3542000.00) * 100
            memberremamt=3542000.00 - parseFloat(pv)
            memberremwidth = (348/3542000.0) * parseFloat(pv) + "px"
            memprevlevel="Double Crown Ambassador"
        }
        if (parseFloat(pv)>=3542000.00&&parseFloat(pv)<8855000.00){
            memberLevel="Double Crown Ambassador"
            memberPercent = (parseFloat(pv)/8855000.00) * 100
            memberremamt=8855000.00 - parseFloat(pv)
            memberremwidth = (348/8855000.0) * parseFloat(pv) + "px"
            memprevlevel="Triple Crown Ambassador"
        }
        if (parseFloat(pv)>=8855000.00){
            memberLevel="Triple Crown Ambassador"
            memberPercent = 100
            memberremwidth = "348px"
            memprevlevel = ""
            
        }
        // // console.log(memberLevel)
        if (type=="level"){
        return memberLevel}
        if (type=="percent"){
        return memberPercent
        }
        if (type=="remamt"){
        return memberremamt
        }
        if (type=="remwidth"){
        return memberremwidth
        }
        if (type=="prevlevel"){
        return memprevlevel
        }
    }

    const selectPackageColor = (detail, where) => {
        let color
        if (detail.package_status=="Accomplished" && detail.package_type=="Package D" && where=="One"){
            color = "#00C561"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package D" && where=="Two"){
            color = "#008941"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package D" && where=="Three"){
            color = "#EAFFE9"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package C" && where=="One"){
            color = "#0096F0"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package C" && where=="Two"){
            color = "#007CC7"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package C" && where=="Three"){
            color = "#F8F9FF"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package B" && where=="One"){
            color = "#F06700"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package B" && where=="Two"){
            color = "#C75400"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package B" && where=="Three"){
            color = "#FFF8F6"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package A" && where=="One"){
            color = "#B200F0"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package A" && where=="Two"){
            color = "#8603B4"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package A" && where=="Three"){
            color = "#FBEFFF"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package AA" && where=="One"){
            color = "#0035F0"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package AA" && where=="Two"){
            color = "#04269C"
        }
        if (detail.package_status=="Accomplished" && detail.package_type=="Package AA" && where=="Three"){
            color = "#F3F6FF"
        }
        return color
    }
        // Sample data for both bar and line charts
        
        const wallet_data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June'],
            datasets: [
              {
                label: 'Transactions',
                data: [65, 59, 80, 81, 56, 55], // Example sales data for each month
                backgroundColor: '#53AEFF', // Background color for bars
                borderColor: '#53AEFF', // Border color for bars
                borderWidth: 1 // Border width for bars
              }
            ]
          };
          const withdraw_data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June'],
            datasets: [
              {
                label: 'Transactions',
                data: [65, 59, 80, 81, 56, 55], // Example sales data for each month
                backgroundColor: '#61FF92', // Background color for bars
                borderColor: '#61FF92', // Border color for bars
                borderWidth: 1 // Border width for bars
              }
            ]
          };
          
  
  const chartOptions = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };
  const insightChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#64748B",
          maxRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          color: "#64748B",
        },
        grid: {
          color: "rgba(148, 163, 184, 0.18)",
        },
      },
    },
  };
  const insightLineOptions = {
    ...insightChartOptions,
    elements: {
      line: {
        borderWidth: 2,
      },
    },
  };
        const lineChartData = {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
          datasets: [
            {
              label: 'Line Chart Data',
              fill: false,
              lineTension: 0.1,
              backgroundColor: 'rgba(75,192,192,0.4)',
              borderColor: 'rgba(75,192,192,1)',
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointBorderWidth: 1,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: 'rgba(75,192,192,1)',
              pointHoverBorderColor: 'rgba(220,220,220,1)',
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: [30, 40, 50, 60, 70, 80, 90],
            },
          ],
        }
        function stringToColor1(string) {
            let hash = 0;
            let i;
          
            /* eslint-disable no-bitwise */
            for (i = 0; i < string.length; i += 1) {
              hash = string.charCodeAt(i) + ((hash << 5) - hash);
            }
          
            let color = '#';
          
            for (i = 0; i < 3; i += 1) {
              const value = (hash >> (i * 8)) & 0xff;
              color += `00${value.toString(16)}`.slice(-2);
            }
            /* eslint-enable no-bitwise */
          
            return color;
          }
          function stringToColor2(string) {
            let hash = 0;
            let i;
          
            /* eslint-disable no-bitwise */
            for (i = 0; i < string.length; i += 1) {
              hash = string.charCodeAt(i) + ((hash << 10) - hash);
            }
          
            let color = '#';
          
            for (i = 0; i < 3; i += 1) {
              const value = (hash >> (i * 8)) & 0xff;
              color += `00${value.toString(16)}`.slice(-2);
            }
            /* eslint-enable no-bitwise */
          
            return color;
          }
        function stringAvatar(name) {
            return {
              sx: {
                // bgcolor: stringToColor(name),
                background:`linear-gradient(45deg, ${stringToColor1(name)} 10%, ${stringToColor2(name)} 90%)`,
                width:"72px",height:"72px",
                fontSize:"32px"
              },
              children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
            };
          }
          function teamStringAvatar(name) {
            return {
              sx: {
                // bgcolor: stringToColor(name),
                background:`linear-gradient(45deg, ${stringToColor1(name)} 10%, ${stringToColor2(name)} 90%)`,
                // background:"red",
                width:"72px",height:"72px",
                borderRadius:"0px"
              },
              children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
            };
          }
        //   useEffect(()=>{
        //     // console.log(team_member.length,loopCall)
        //     if(loopCall){
        //         // console.log(item.id)
        //         // console.log(res)
        //         res.team_member?.map(item=>{
        //             // console.log(item)
        //             teamPreview(item.user_id)
        //     })
        //         setTeamMemeber([])
        //         // // console.log("continuing the loop")
                
        //         // teamPreview(79)

        //     }
            
        //   },[res])
        //   const teamPreview=async(id)=>{
        //     // console.log(id)
        //     // setOpen(true)
        //     setLoopCall(false)
        //    await CustomAxios.get(`team-member/${id}`).then((res)=>{
        //         // console.log(res)
        //         setTeamMemeber(prev =>[...prev, res.data])
                
        //     }).catch(error => {
        //         // console.log(error)
        //     })

        //   }
          useEffect(()=>{
            // console.log(userreponse)
            if (Object.keys(userreponse).length>0&&res?.team_growth){
                // console.log(res?.team_growth)
                let returnedData=getLastSixMonthsData(res?.team_growth)
                if (returnedData){
            returnedData=Object.keys(returnedData)?.sort((a, b) => {
                const [aMonth, aYear] = a.split(' ');
                const [bMonth, bYear] = b.split(' ');

                const aDate = new Date(`${aMonth} 1, ${aYear}`);
                const bDate = new Date(`${bMonth} 1, ${bYear}`);

                return aDate - bDate;
            }).reduce((sortedAcc, key) => {
                sortedAcc[key] = returnedData[key];
                return sortedAcc;
            }, {});;


            // console.log(returnedData)
            setTeamGrowth(returnedData)
            const chartData = {
                labels: Object.keys(returnedData),
                datasets: [
                  {
                    label: 'Team Growth',
                    data: Object.values(returnedData), // counts per month
                    backgroundColor: '#61FF92',
                    borderColor: '#61FF92',
                    borderWidth: 1,
                  }
                ],
              };
            setTeamChart(chartData)
            teamPerformanceValues(res.team_growth,0)
                
            }
            
        }
          },[userreponse])
          const teamPerformanceValues=(data,member)=>{
            // console.log(data)
            const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
            const performer=data?.map(item=>{
                return{name:capitalize(item.first_name)+" "+capitalize(item.last_name),id:item.id}
            })
            setTeamPerformance(performer)
            const chartData = {
                labels: data[member]?.earning?.map(item=>month[item.created_on_at_month-1]) ,
                datasets: [
                  {
                    label:"Avg of Earnings",
                    data:  data[member]?.earning?.map(item=>item.total), // Example sales data for each month
                    backgroundColor: '#61FF92', // Background color for bars
                    borderColor: '#61FF92', // Border color for bars
                    borderWidth: 1 // Border width for bars
                  }
                ]}
                setPerformanceChart(chartData)

          }
        // console.log(team_member)
          const modalOpen=(id)=>{
           const member=team_member.filter(item=>item.member.id==id)
           // console.log(member)
           setSubMember(member[0])
          

          }
        //   const third_stage_member=async(id)=>{
        //     const present=treeBoard.filter(item=>item.member?.id==id)
        //     if (present.length<=0&& treeBoard.length<10){
        //         const tree=team_member.filter(item=>item.member.id==id)
        //         // console.log(tree[0])
        //         setTeamMemeber([])
        //         setSecondLevel(false)
        //          setTreeBoard(prev=>[...prev,tree[0]])
        //         //  console.log("id list")
        //          await CustomAxios.get(`team-member/${id}`).then((res)=>{
        //                 // console.log(res)
                       
        //                 res.data?.members.map(item=>teamPreview(item.id))
        //                 // setOpen(true)
        //             }).catch(error => {
        //                 // console.log(error)
        //             })
        //     }           //
        //   }
          function getLastSixMonthsData(data) {
            const sixMonthsAgo = new Date();
            // console.log(data)
            sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
           const filtered= data?.filter(item => new Date(item?.date_joined) >= sixMonthsAgo);

            return filtered?.reduce((acc, obj) => {
                // console.log(obj)
                const date = new Date(obj.date_joined);
                const monthYear = date.toLocaleString('default',  { month: 'long', year: 'numeric' }); // Format: YYYY-MM
                // console.log(monthYear)
        
                if (!acc[monthYear]) {
                    acc[monthYear] = 0;
                }
        
                acc[monthYear]= 1 + parseInt(acc[monthYear]);
                return acc
            }, {});
        }
        function buildDailySignupInsights(growthEntries = []) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const dayBuckets = [];
            const dayCounts = {};

            for (let index = 6; index >= 0; index -= 1) {
                const bucketDate = new Date(today);
                bucketDate.setDate(today.getDate() - index);
                const bucketKey = bucketDate.toISOString().slice(0, 10);

                dayBuckets.push({
                    key: bucketKey,
                    label: bucketDate.toLocaleDateString('en-US', { weekday: 'short' }),
                });
                dayCounts[bucketKey] = 0;
            }

            (growthEntries || []).forEach((entry) => {
                if (!entry?.date_joined) {
                    return;
                }

                const joinedAt = new Date(entry.date_joined);
                if (Number.isNaN(joinedAt.getTime())) {
                    return;
                }

                joinedAt.setHours(0, 0, 0, 0);
                const joinedKey = joinedAt.toISOString().slice(0, 10);

                if (Object.prototype.hasOwnProperty.call(dayCounts, joinedKey)) {
                    dayCounts[joinedKey] += 1;
                }
            });

            const labels = dayBuckets.map((bucket) => bucket.label);
            const signupCounts = dayBuckets.map((bucket) => dayCounts[bucket.key] || 0);
            const cumulativeGrowth = signupCounts.reduce((acc, count, index) => {
                const previousValue = index > 0 ? acc[index - 1] : 0;
                acc.push(previousValue + count);
                return acc;
            }, []);

            const totalThisWeek = signupCounts.reduce((sum, count) => sum + count, 0);
            const bestDayCount = Math.max(...signupCounts, 0);
            const bestDayIndex = signupCounts.findIndex((count) => count === bestDayCount);
            const averagePerDay = totalThisWeek > 0 ? (totalThisWeek / signupCounts.length).toFixed(1) : "0.0";

            return {
                totalThisWeek,
                bestDayCount,
                bestDayLabel: bestDayCount > 0 && bestDayIndex >= 0 ? labels[bestDayIndex] : "No signups",
                averagePerDay,
                signupBar: {
                    labels,
                    datasets: [
                        {
                            label: "Daily Signups",
                            data: signupCounts,
                            backgroundColor: "#00C2FF",
                            borderRadius: 8,
                            borderSkipped: false,
                            maxBarThickness: 28,
                        }
                    ]
                },
                growthLine: {
                    labels,
                    datasets: [
                        {
                            label: "Growth Trend",
                            data: cumulativeGrowth,
                            borderColor: "#0F9D58",
                            backgroundColor: "rgba(15, 157, 88, 0.12)",
                            fill: true,
                            tension: 0.35,
                            pointRadius: 3,
                            pointHoverRadius: 4,
                        }
                    ]
                }
            };
        }
        useEffect(() => {
            setTeamInsights(buildDailySignupInsights(res?.team_growth || []));
        }, [res?.team_growth]);
        // const backWard=async(index,userid)=>{
        //     if (id==userid){
        //         setSecondLevel(true)
        //     }
        //     let team_tree=[...treeBoard] 
        //     team_tree=team_tree.slice(0,index+1)
        //     // console.log(team_tree)
        //     // const tree=team_member.filter(item=>item.member.id==id)
        //         // // console.log(tree[0])
        //         setTeamMemeber([])
        //          setTreeBoard(team_tree)
        //          await CustomAxios.get(`team-member/${userid}`).then((res)=>{
        //                 // // console.log(res)Nivetha@321
                       
        //                 res.data?.members.map(item=>teamPreview(item.id))
        //                 // setOpen(true)
        //             }).catch(error => {
        //                 // console.log(error)
        //             })


        // }
        
    
        // useEffect(() => {
        //     // Group data by levels
        //     const groupByLevel = (data) => {
        //       return data?.reduce((acc, item) => {
        //         const levelKey = `Level ${item.level}`;
        //         if (!acc[levelKey]) {
        //           acc[levelKey] = { users: [], commission: 0 };
        //         }
        //         if (!acc[levelKey].users.includes(item.username)) {
        //             acc[levelKey].users.push(item.username);
        //         }
        //         acc[levelKey].commission += +item.commissions || 0;
        //         return acc;
        //       }, {});
        //     };
        
        //     const groupedDataResult = groupByLevel(commissions);
        //     const sortedLabels = Object.keys(groupedDataResult)
        //     .sort((a, b) => {
        //         const numA = parseInt(a.replace('Level ', ''));
        //         const numB = parseInt(b.replace('Level ', ''));
        //         return numA - numB;
        //     });
        //     setData(groupedDataResult);
        //     const chartData = {
        //       labels: sortedLabels,
        //       datasets: [
        //         {
        //           label: 'Levels',
        //           data: sortedLabels.map(label => groupedDataResult[label].commission),
        //           backgroundColor: '#61FF92',
        //           borderColor: '#61FF92',
        //           borderWidth: 1,
        //           barThickness: 30, 
        //         },
        //       ],
        //     };
        
        //     setCommissionChart(chartData);
        //   }, [commissions]);
        
          const options = {
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const level = context.label;
                    const items = data[level] || { ids: [], commission: 0 };
                    const idsAndLevels = items.users.map((user,ind) => ` ${ind+1}.${user.charAt(0).toUpperCase() + user.slice(1).toLowerCase()}`);
                    return [`Earnings: ${items.commission.toFixed(2)}  `,'','Members :','',...idsAndLevels,''];
                  },
                },
              },
            },
            scales: {
                y: {
                    display: true,
                    beginAtZero: true,
                    ticks: {
                        stepSize: 20, 
                      },
                    title:{
                        text:"Earnings ---->",
                        display:true,
                        color:"grey",
                        fontSize:20,
                        letterSpacing:2.5,
                    },
              },
            },
          };
    

    

    // const handlePayment = async()=>{
    //     let bodyData = new FormData();
    //     bodyData.append("amount", parseFloat(490).toString());
    //     bodyData.append("user_id", userid);
    //     bodyData.append("transaction_fee",parseFloat(490*0.0195).toString())
        
    //     const data = await CustomAxios.post('initiate-add-funds/',bodyData).then((res)=>{return res.data})

    //     let cashfree;    
    //     cashfree = await load({
    //         mode: process.env.REACT_ENV == "production"?"production":"sandbox"
    //     });
    //     let checkoutOptions = {
    //         paymentSessionId: data.payment_session_id,
    //         redirectTarget: "_modal",
    //     };
    //     cashfree.checkout(checkoutOptions).then((result) => {
    //         if(result.error){
    //             // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
    //             console.log("User has closed the popup or there is some payment error, Check for Payment Status");
    //             console.log(result.error);
    //         }
    //         if(result.redirect){
    //             // This will be true when the payment redirection page couldnt be opened in the same window
    //             // This is an exceptional case only when the page is opened inside an inAppBrowser
    //             // In this case the customer will be redirected to return url once payment is completed
    //             console.log("Payment will be redirected");
    //         }
    //         if(result.paymentDetails){
    //             // This will be called whenever the payment is completed irrespective of transaction status
    //             console.log("Payment has been completed, Check for Payment Status");
    //             console.log(result);
    //             handlePaymentSuccess(data);

    //         }
    //     });
    // }

    const handlePaymentSuccess = async(response)=>{
        let bodyData = new FormData();
        bodyData.append("response", JSON.stringify(response));

        CustomAxios.post('add-funds/',bodyData).then((res)=>{
            if(res.status == 200){
                dispatch(updateSnackBarSeverity('success'))
                dispatch(updateSnackBarMessage(res.data.message))
                dispatch(updateSnackBarOpen(true))
            }
            else{
                dispatch(updateSnackBarSeverity('error'))
                dispatch(updateSnackBarMessage(res.data.message))
                dispatch(updateSnackBarOpen(true))
            }
        })
    }

    const handleTransfer = (val)=>{
        CustomAxios.post('transfer-funds/',{
            amount:Transferamt,
            recipient_username: val === 'me'?userreponse?.user.username:ReUsername,
            user_id:resolvedUserId,
            tf:val
        }).then((res)=>{
            if(res.status == 200){

                dispatch(updateSnackBarSeverity('success'))
                dispatch(updateSnackBarMessage(res?.data?.message))
                dispatch(updateSnackBarOpen(true))
            }
            else{
                dispatch(updateSnackBarSeverity('error'))
                dispatch(updateSnackBarMessage(res.data.message))
                dispatch(updateSnackBarOpen(true))
            }
        }).catch((err)=>{
            // console.log(err.response)
            dispatch(updateSnackBarSeverity('error'))
            dispatch(updateSnackBarMessage(err?.response?.data?.message?.toString()))
            dispatch(updateSnackBarOpen(true))
        })
        
        setIsMCTransferClicked(false)
        setIsMETransferClicked(false)
        setTransferModalOpen(false)
        setTransferAmt(0.00)
        setRecUsername(null)
    }
    const setTransferReferalModalHandle=(closeStatus)=>{
    // console.log(closeStatus,transferReferalClose)
    if(!closeStatus){
        setTransferReferalModal(false)
        // dispatch(updateTranferReferralclose(false))
        setRestrictClose(false)
    }
    else{
        setRestrictClose(true)
    }

}

    // Tree Node Component for hierarchical display
    const TreeNode = ({ member, level = 0, index = 0, isLast = true }) => {
        const nodeId = `${level}-${index}`;
        const isExpanded = expandedNodes.has(nodeId);
        const hasChildren = member?.members?.length > 0;

        const handleToggle = () => {
            const newExpanded = new Set(expandedNodes);
            if (isExpanded) {
                newExpanded.delete(nodeId);
            } else {
                newExpanded.add(nodeId);
            }
            setExpandedNodes(newExpanded);
        };

        const handleNodeClick = () => {
            if (hasChildren) {
                handleToggle();
            }
        };

        return (
            <Box>
                <Card
                    sx={{
                        mb: 1,
                        cursor: hasChildren ? 'pointer' : 'default',
                        border: level === 0 ? '2px solid #00C2FF' : '1px solid #e0e0e0',
                        backgroundColor: level === 0 ? '#f8f9ff' : 'white',
                        '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-2px)',
                            transition: 'all 0.2s ease'
                        },
                        transition: 'all 0.2s ease',
                        position: 'relative',
                        '&::before': level > 0 ? {
                            content: '""',
                            position: 'absolute',
                            left: -16,
                            top: 20,
                            width: 16,
                            height: 2,
                            backgroundColor: '#ccc',
                        } : {},
                        '&::after': level > 0 ? {
                            content: '""',
                            position: 'absolute',
                            left: -16,
                            top: -10,
                            width: 2,
                            height: 30,
                            backgroundColor: '#ccc',
                        } : {},
                    }}
                    onClick={handleNodeClick}
                >
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            {member?.imageurl ? (
                                <img
                                    src={member.imageurl}
                                    style={{
                                        width: level === 0 ? "48px" : "40px",
                                        height: level === 0 ? "48px" : "40px",
                                        objectFit: "cover",
                                        border: "2px solid #00C2FF",
                                        borderRadius: "50%"
                                    }}
                                    alt='Profile'
                                />
                            ) : (
                                <Avatar
                                    {...stringAvatar(capitalize(member?.first_name || "") + " " + capitalize(member?.last_name || ""))}
                                    sx={{
                                        width: level === 0 ? "48px" : "40px",
                                        height: level === 0 ? "48px" : "40px",
                                        border: "2px solid #00C2FF"
                                    }}
                                />
                            )}

                            <Box sx={{ flex: 1 }}>
                                <Typography variant={level === 0 ? "h6" : "subtitle1"} sx={{ fontWeight: 'bold', color: '#333' }}>
                                    {capitalize(member?.first_name || "")} {capitalize(member?.last_name || "")}
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 2, mt: 0.5, flexWrap: 'wrap' }}>
                                    {level > 0 && (
                                        <Typography variant="caption" sx={{
                                            backgroundColor: '#f0f0f0',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            color: '#666'
                                        }}>
                                            Level {level}
                                        </Typography>
                                    )}

                                    <Typography variant="caption" sx={{
                                        backgroundColor: '#e3f2fd',
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                        color: '#1976d2'
                                    }}>
                                        👥 {member?.members?.length || 0} members
                                    </Typography>

                                    {member?.mobileno && (
                                        <Typography variant="caption" sx={{
                                            backgroundColor: '#f3e5f5',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            color: '#7b1fa2'
                                        }}>
                                            📱 {member.mobileno}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            {hasChildren && (
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleToggle();
                                    }}
                                    sx={{ color: '#666' }}
                                >
                                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            )}
                        </Box>
                    </CardContent>
                </Card>

                {hasChildren && (
                    <Collapse in={isExpanded}>
                        <Box sx={{
                            ml: level === 0 ? 0 : 4,
                            pl: level === 0 ? 0 : 2,
                            borderLeft: level > 0 ? '2px solid #e0e0e0' : 'none',
                            position: 'relative'
                        }}>
                            {member.members.slice(0, 10).map((childMember, childIndex) => (
                                <TreeNode
                                    key={`${level + 1}-${childIndex}`}
                                    member={childMember}
                                    level={level + 1}
                                    index={childIndex}
                                    isLast={childIndex === member.members.length - 1}
                                />
                            ))}
                            {member.members.length > 10 && (
                                <Typography variant="caption" sx={{
                                    display: 'block',
                                    textAlign: 'center',
                                    py: 1,
                                    color: '#666',
                                    fontStyle: 'italic'
                                }}>
                                    ... and {member.members.length - 10} more members
                                </Typography>
                            )}
                        </Box>
                    </Collapse>
                )}
            </Box>
        );
    };
    return (
        <Box sx={{ bgcolor: isMobile ? "#fff" : "grey.100",minHeight: "", display: "flex", alignItems: "start", justifyContent: "start" }}>
            <Layout />
            <MessageBar />

            <Box sx={{ alignSelf: "start", marginTop: "140px",height:'130%', marginBottom: "100px", justifySelf: "center", display: "flex", justifyContent: "center", width: "100%", gap: "36px" }}>
                {isTabletHori && <Paper sx={{ height: "max-content",width:"20%",position:"sticky",top:"140px" }} elevation={1}>
                <SideBarList />
                </Paper>}
                {isDetailsLoading ? (
                    <Box sx={{ width: { xs: "100%", md: "95%", lg: "65%" }, display: "flex", flexDirection: "column",justifyContent: "center", alignItems: "center", minHeight: 200, gap: 2 }}>
                        <CircularProgress sx={{ color: "inherit" }} />
                        <TranslateText sx={{ fontSize: "14px", color: "grey.600" }}>
                            Please wait while we load your dashboard...
                        </TranslateText>
                    </Box>
                   ): (
                <Box elevation={1} sx={{ width: {xs:"100%",md:"95%",lg:"65%"}, height:isLaptop?"175%":"450%", display: "flex", flexDirection: "column", gap:{ xs:"0px ",md:"36px"}, overflowY:"auto", "&::-webkit-scrollbar": {width: "0px",}, scrollbarWidth: "none", msOverflowStyle: "none", "::-webkit-scrollbar-track":{backgroundColor: "transparent",} }}>
	                {hasOverviewData ? (
	                <Box sx={{ display: "flex", flexDirection: "column", gap: isLaptop?"24px":"0px", padding: "24px", width:"100%", height:isLaptop?"194px":"375px", justifyContent:isLaptop?"normal":"center", alignItems:isLaptop?"normal":"center"}} component={isLaptop ? Paper : Box}>
	                <Box sx= {{ display: "flex", flexDirection:isLaptop?"row":"column", justifyContent:isLaptop?"space-between":"center",alignItems:isLaptop?"normal":"center", gap:isLaptop?"":"24px", }}>
	                    <Box sx={{ display:"flex", flexDirection:"column", gap:"16px", alignItems:isLaptop?"normal":"center", justifyContent:isLaptop?"normal":"center", textAlign:isLaptop?"":"center"}}>
                    <Box sx={{ display:"flex", flexDirection:isLaptop?"row" :"column", gap:isLaptop?"0px":"20px", alignItems:isLaptop?"normal":"center"}}>
                    {(profile||imageurl)&&imagestatus ? <img src={profile||imageurl} style = {{width:"72px",height:"72px",objectFit:"cover",background:"#CBD5E1",border:"none", borderRadius:"36px"}} alt='Profile' onError={(e) => {setImageStatus(false)}}  />:<Avatar {...stringAvatar(capitalize(first_name)+" "+capitalize(last_name))}  />}
                    <Box sx={{ display:"flex", flexDirection:"column", marginLeft:isLaptop?"32px":"0px", gap:"3px", alignItems:isLaptop?"normal":"center"}}>
                    <Box sx={{ display:"flex", flexDirection:"row", gap:"3px", alignItems:isLaptop?"normal":"center" }}>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">{capitalize(first_name)} {capitalize(last_name)}</TranslateText>
                    {showPvRankIcons && pvRankAmount>=89000.00 && <img src={pvRankAmount>=89000.00&&pvRankAmount<178000.00?AmbIcon:pvRankAmount>=178000.00&&pvRankAmount<355000.00?GoldAmbIcon:pvRankAmount>=355000.00&&pvRankAmount<709000.00?AmbIcon:pvRankAmount>=709000.00&&pvRankAmount<900000.00?DiaIcon:pvRankAmount>=900000.00&&pvRankAmount<1770000.00?DiaIcon:pvRankAmount>=1770000.00?CrownIcon:null} style={{width:"18px", height:"18px"}}/>}
                    {showPvRankIcons && ((pvRankAmount>=355000.00&&pvRankAmount<709000.00) || (pvRankAmount>=900000.00&&pvRankAmount<1770000.00) || (pvRankAmount>=3542000.00)) && <img src={pvRankAmount>=355000.00&&pvRankAmount<709000.00?AmbIcon:pvRankAmount>=900000.00&&pvRankAmount<1770000.00?DiaIcon:pvRankAmount>=3542000.00?CrownIcon:null} style={{width:"18px", height:"18px"}}/>}
                    {showPvRankIcons && pvRankAmount>=8855000.00 && <img src={pvRankAmount>=8855000.00?CrownIcon:null} style={{width:"18px", height:"18px"}}/>}
                    </Box>
                    {/* <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.700">User Name : { !userreponse?.user?.username? "-":userreponse?.user?.username}</TranslateText> */}
                    <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.700">Member ID : { !userreponse?.user?.mid? "-":userreponse?.user?.mid}</TranslateText>
                    {city!="" || country!="" ? <TranslateText sx={{ fontWeight: 400, fontSize: "10px" }} color="grey.700">Member since: { !userreponse?.user?.date_joined? "-":formatdate(userreponse?.user?.date_joined)} | {city}, {country}</TranslateText>:
                    <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.700">Member since: { !userreponse.user?.date_joined? "-":formatdate(userreponse?.user?.date_joined)} </TranslateText>}
                    </Box>
                    </Box>
                    <Button variant="contained" sx={formStyle.button} onClick={()=>handleCopyurl()}>
                    <Box component="span" sx={{display:"inline-flex",alignItems:"center",mr:"8px"}}>
                    <LinkIcon />
                </Box>Sponsor Referral Link</Button>
                </Box>
                {/* <Box sx={{ display:"flex", flexDirection:"column", height:"70px", gap:"4px", alignItems:"center" }}>
                    <Box sx={{ display:"flex", flexDirection:"column",  height:"34px", gap:"2px",width:"100%" }}>
                        <Box sx={{ display:"flex", flexDirection:"row", height:"20px", justifyContent:"space-between"}}>
                            <TranslateText sx={{ fontWeight: 700, fontSize: "14px", lineHeight:"20px"}} color="grey.900">{!userreponse?.pv?'--.--':getMemberLevel(userreponse?.pv/0.6, "level")}</TranslateText>
                            <TranslateText sx={{ fontWeight: 700, fontSize: "14px" , lineHeight:"16px" }} color="#00E471">{!userreponse?.pv?'--.--':getMemberLevel(userreponse?.pv/0.6, "percent")?.toFixed(2)}%</TranslateText>
                        </Box>
                    <Box sx={{ display:"flex", flexDirection:"column", width:"100%" ,height:"12px", gap:"10px", background:"#EDF1F9", borderRadius:"6px" }}>
                            <Box sx={{ display:"flex", flexDirection:"column", width:getMemberLevel(userreponse?.pv/0.6, "remwidth"), height:"12px", borderRadius:"6px", background:"#00E471"}}></Box>
                        </Box>
                    </Box>
                    {parseFloat(userreponse?.pv/0.6)>=8855000.00?<TranslateText sx={{ fontWeight: 400, fontSize: "11px" , lineHeight:"16px", height:"32px" }} color="grey.700">Congratulations </TranslateText>
	                    :userreponse?.user?.referral_code!=undefined?<TranslateText sx={{ fontWeight: 400, fontSize: "12px" , lineHeight:"16px", height:"32px" }} color="grey.700">Enter Referral Code to activate your account as Member.</TranslateText>:<TranslateText sx={{ fontWeight: 400, fontSize: "12px" , lineHeight:"16px", height:"32px" }} color="grey.700">To become an {getMemberLevel(userreponse?.pv/0.6, "prevlevel")}, you need {!userreponse?.pv?"--.--":addCurrencyAndCommafy((getMemberLevel(userreponse?.pv/0.6, "remamt")))}.</TranslateText>}
	                </Box> */}
	                </Box>
	                    </Box>
	                    ) : (
	                    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", padding: "24px", width:"100%", height:isLaptop?"194px":"375px", justifyContent:"center" }} component={isLaptop ? Paper : Box}>
	                        <Skeleton variant="text" width="40%" height={36} />
	                        <Skeleton variant="text" width="25%" height={24} />
	                        <Skeleton variant="text" width="55%" height={24} />
	                        <Skeleton variant="rounded" width={isLaptop ? 220 : "100%"} height={40} />
	                    </Box>
	                    )}
                    {/* <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", padding: "24px", width:"100%", }} component={isLaptop ? Paper : Box}>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Overview</TranslateText>
                    <Grid container  sx={{ display: "flex", flexDirection:{xs:"column",sm:"row"},alignItems:"center", justifyContent:"center", width:"100%", overflowX:"auto", "&::-webkit-scrollbar": {width: "0px",}, scrollbarWidth: "none", msOverflowStyle: "none", "::-webkit-scrollbar-track":{backgroundColor: "transparent",} }}>
                    {/* <Tooltip title="Coming Soon" arrow> 
                    <Grid item xs={12} sm={6} md={4} sx={{padding:"8px",width:"100%"}}>
                     <Grid  sx={{ display:"flex", flexDirection:"column", height:"88px", width:"100%",justifyContent:"center", borderRadius:"8px", border:"1px solid #5BB1FF", background:"#E9F1FF", padding:"12px 18px 12px 18px", gap:"24px",opacity:"1", cursor:"pointer"}} disabled={true}>
                            <Box sx={{ display:"flex", flexDirection:"row", height:"64px", gap:"24px", alignItems:"center"}} >
                                <img src={WalletIcon} style={{width:"32px", height:"32px"}}/>
                                <Box sx={{ display:"flex", flexDirection:"column", height:"64px", width:"100%", gap:"2px"}}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color="grey.900">MAYI Pay</TranslateText>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">${walletBalanceDisplay != null ? walletBalanceDisplay : "--"}</TranslateText>
                                <Box sx={{ display:"flex", flexDirection:"row", widht:"100%", height:"16px", gap:"4px", alignItems:"center",justifyContent:"space-between"}}>
                                    {/* <img src={PlusIcon} style={{ width:"9.33px", height:"9.33px"}}/> 
                                    <Button sx={{ fontWeight: 400, fontSize: "11px",color:"#007CC7",maxWidth:"unset",padding:0}} onClick={()=>handlePayment()}>Add Money</Button>
                                    <Button sx={{ fontWeight: 400, fontSize: "11px",color:"#007CC7",maxWidth:"unset",padding:0}} onClick={()=>{setIsMCTransferClicked(true);setTransferModalOpen(true)}}>Transfer</Button>
                                </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                        
                        </Tooltip>
                        <Grid item xs={12} sm={6} md={3} sx={{padding:"8px",width:"100%"}}>
                        <Grid  sx={{ display:"flex", flexDirection:"column", height:"88px",  width:"100%", borderRadius:"8px", border:"1px solid #00E471",  background:"#F5FFF2", padding:"12px 18px 12px 18px", gap:"24px",cursor:"pointer"}}>
                        <Box sx={{ display:"flex", flexDirection:"row", height:"64px", width:"100%", gap:"24px", alignItems:"center"}}>
                                <img src={SalaryIcon} style={{width:"32px", height:"32px"}}/>
                                <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", height:"64px", width:"100%", gap:"16px"}}>
                                    <Stack sx={{flexDirection:"column",alignItems:"flex-start",width:"100%"}}>
                                        <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color="grey.900">MAYI Net Worth</TranslateText>
                                        <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900"> { !canShowNetWorth ? "--.--" : addCurrencyAndCommafy(netWorthTotal) }</TranslateText>
                                    </Stack>
                                {/* <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">{ !userreponse.pv? "--.--":"("+(parseFloat(userreponse?.pv)).toFixed(2)+" PV)"}</TranslateText> 
                                </Box>
                            </Box>
                        </Grid>
                        </Grid>
                        <Tooltip title="Coming Soon" arrow>
                        <Grid item xs={12} sm={6} md={3} sx={{padding:"8px",width:"100%"}}>
                        <Grid sx={{ display:"flex", flexDirection:"column", height:"88px", width:"100%",borderRadius:"8px", border:"1px solid #FF8D4F",  background:"#FFEDE6", padding:"12px 18px 12px 18px", gap:"24px", cursor:"pointer",opacity:"0.5"}} disabled={true}>
                        <Box sx={{ display:"flex", flexDirection:"row", height:"64px", gap:"24px", alignItems:"center"}}>
                                <img src={AtmIcon} style={{width:"32px", height:"32px"}}/>
                                <Box sx={{ display:"flex", flexDirection:"column", height:"64px", width:"100%", gap:"2px", justifyContent:"center"}}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color="grey.900">MAYI Earnings</TranslateText>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">${withdrawalAvailableDisplay != null ? withdrawalAvailableDisplay : "--"}</TranslateText>
                                {/* <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">{"(" + 0.00 + " PV)"}</TranslateText> 
                                <Box sx={{ display:"flex", flexDirection:"row", widht:"100%", height:"16px", gap:"8px", alignItems:"center", justifyContent:"space-between"}}>
                                    <TranslateText sx={{ fontWeight: 400, fontSize: "11px"}} color="#007CC7">Withdraw</TranslateText>
                                    <Button sx={{ fontWeight: 400, fontSize: "11px",color:"#007CC7",maxWidth:"unset",padding:0}}  onClick={()=>{setIsMETransferClicked(true);setTransferModalOpen(true)}}>Transfer</Button>
                                </Box>
                                </Box>
                            </Box>
                        </Grid>
                        </Grid>
                        </Tooltip>
                    </Grid>
                    <Tooltip title="Coming Soon" arrow>
                    <Box sx={{ display:"flex", flexDirection:"column", width:"100%",maxWidth:"100%",  padding:"0px 0px 24px 0px", gap:"16px", opacity:"0.5", cursor:"pointer"}} disabled={true}>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Transaction History</TranslateText>
                    <Box sx={{ display:"flex", flexDirection:{xs:"column",sm:"row"}, gap:"16px",alignItems:"center",justifyContent:"space-between"}}>
                    <Box sx={{ display:"flex", flexDirection:"column",width:{xs:"100%",sm:"50%"},   gap:"16px" }}>
                        <Box sx={{ display:"flex", flexDirection:"column",width:"100%" ,border:"1px solid lightgrey", borderRadius:"8px" }}>
                            <Box sx={{ display:"flex", flexDirection:"row", width:"100%",justifyContent:"space-between", padding:"16px", alignItems:"center", borderBottom:"1px solid lightgrey" }} >
                                <Box sx={{ display:"flex", flexDirection:"column", width:"50%", gap:"8px" }}>
                                <Box sx={{ display:"flex", flexDirection:"row", width:"80%", height:"19px", gap:"8px" }}>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px", lineHeight:"16px" }} color="grey.900">MAYI-Wallet</TranslateText>
                                <img src={InfoIcon} style={{width:"16px", height:"16px"}}/>
                                </Box>
                                
                                </Box>
                            </Box>
                            
                            <Bar data={wallet_data} options={chartOptions} style={{ width:"100%", height:"250px"}}/>
                        </Box>
                    </Box>
                    <Box sx={{ display:"flex", flexDirection:"column",width:{xs:"100%",sm:"50%"},  gap:"16px" }}>
                        <Box sx={{ display:"flex", flexDirection:"column"  , border:"1px solid lightgrey", borderRadius:"8px" }}>
                            <Box sx={{ display:"flex", flexDirection:"row", width:"100%", justifyContent:"space-between", padding:"16px", alignItems:"center", borderBottom:"1px solid lightgrey" }} >
                                <Box sx={{ display:"flex", flexDirection:"column", width:"50%", gap:"8px" }}>
                                <Box sx={{ display:"flex", flexDirection:"row", width:"80%", height:"19px", gap:"8px" }}>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px", lineHeight:"16px" }} color="grey.900">Withdrawn</TranslateText>
                                <img src={InfoIcon} style={{width:"16px", height:"16px"}}/>
                                </Box>
                                
                                </Box>
                            </Box>
                            {withdraw_data&&
                            <Bar data={withdraw_data} options={chartOptions} style={{ width:"100%", height:"250px"}}/>}
                        </Box>
                    </Box>
                    </Box>
                    </Box>
                    </Tooltip>
                    </Box> */}
                    {/* <GoalStatus /> */}
                    {/* <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", padding: "24px", width:"100%",}} component={isLaptop ? Paper : Box}>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Packages</TranslateText>
                    <Stack gap={"24px"} sx={{flexDirection:"row",alignItems:"center",justifyContent:"space-between"}}>
                        {isTablet || isLaptop ?<Stack>
                            <Button disabled={ activeSlide === 0 ? true : false } sx={[{minWidth:"36px",border:activeSlide === 0 ? "1px solid #CBD5E1" : "1px solid #64748B", color: activeSlide === 0 ? "#CBD5E1" :"#64748B", borderRadius:"4px",p:"8px"}]} onClick={()=>{sliderRef.current?.slickPrev()}}><ChevronLeft /></Button>
                        </Stack>:null}
                        {isTablet || isLaptop ? <Stack sx={{width:"calc(100% - 132px)"}}>
                            <Slider ref={sliderRef} {...packageSliderSettings}  >
                                {packagedetails?.length>0 ? packagedetails.map((detail, index) => (
                                    <Box sx={{ display:"flex", flexDirection:"column", maxWidth:"60%",minWidth:"315px", height:"100%",mr:"24px" }}>
                                        <Box sx={{ display:"flex", flexDirection:"column",width:"315px", height:"220px", borderRadius:"8px 8px 0px 0px", border:"1px solid #E5E8F0", background:"#FFFFFF", gap:"12px", justifyContent:"center" }}>
                                            <Box sx={{ display:"flex", flexDirection:"row",width:"280px", height:"24px", justifyContent:"space-between" }}>
                                                <Box sx={{ display:"flex", flexDirection:"column", width:"96px", height:"24px", borderRadius:"0px 12px 12px 0px", padding:"4px 6px 4px 6px", gap:"10px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FFEDEA" }}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color={detail.package_status=="Accomplished"?"#FFFFFF":"#FF5449"}>{detail.package_status}</TranslateText>
                                                </Box>
                                                <Tooltip title="Coming Soon" arrow>
                                                <img src={ThreeDotIcon} style={{width:"3.33px", height:"13.33px", marginTop:"4px", cursor:"pointer"}}/>
                                                </Tooltip>
                                            </Box>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"121px", gap:"10px", padding:"0px 16px 0px 16px" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"121px", gap:"8px" }}>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"100%", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">{detail.package_type} ({!detail.package_amount?"--.--":addCurrencyAndCommafy(detail.package_amount)})</TranslateText>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{userreponse?.orders_pv? 
                                                    ( parseFloat(userreponse.orders_pv[index+1]) > ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) ? 
                                                        ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) : userreponse.orders_pv[index+1] )    + "/" + ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) 
                                                    : 
                                                    "--/--"
                                                }</TranslateText>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">(Exclusive of Other Charges)</TranslateText>
                                                </Box>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"100%", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">Earnings</TranslateText>
                                                <Box>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.package_amount?"--.--":addCurrencyAndCommafy(detail?.commision_amount)}</TranslateText>
                                                
                                                </Box>
                                                </Box>
                                            </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column", width:"315px", height:"4px", gap:"10px", background:"#EDF1F9" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:calculateWidth(detail), height:"4px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FF5449"}}></Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column",width:"315px", height:"40px", borderRadius:"0px 0px 8px 8px", justifyContent:"center", border:"1px solid #E5E8F0", padding:"12px",background:detail.package_status=="Accomplished"?selectPackageColor(detail, "Three"):"#FFF8F7"}}>
                                            {detail.package_status=="Accomplished"?
                                            <TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color={detail.package_status=="Accomplished"?selectPackageColor(detail, "Two"):"#DE3730"}>Ready for Withdraw</TranslateText>
                                            :<TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color="#DE3730">Activate Withdrawals with a Rs. {detail.package_remaining_amount} purchase of product</TranslateText>}
                                        </Box>
                                    </Box>
                                ))
                                :package_details.map((detail, index) => (
                                    <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"100%" }}>
                                        <Box sx={{ display:"flex", flexDirection:"column", height:"220px", borderRadius:"8px 8px 0px 0px", border:"1px solid #E5E8F0", background:"#FFFFFF", gap:"12px", justifyContent:"center" }}>
                                            <Box sx={{ display:"flex", flexDirection:"row",height:"24px", justifyContent:"space-between" }}>
                                                <Box sx={{ display:"flex", flexDirection:"column", width:"96px", height:"24px", borderRadius:"0px 12px 12px 0px", padding:"4px 6px 4px 6px", gap:"10px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FFEDEA" }}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color={detail.package_status=="Accomplished"?"#FFFFFF":"#FF5449"}>{detail.package_status}</TranslateText>
                                                </Box>
                                                <Tooltip title="Coming Soon" arrow>
                                                <img src={ThreeDotIcon} style={{width:"3.33px", height:"13.33px", marginTop:"4px", cursor:"pointer"}}/>
                                                </Tooltip>
                                            </Box>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"185px", height:"121px", gap:"10px", padding:"0px 16px 0px 16px" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"170px", height:"121px", gap:"8px" }}>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"170px", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">{detail.package_type}</TranslateText>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.package_amount?"--.--":addCurrencyAndCommafy(detail.package_amount)}</TranslateText>
                                                </Box>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"170px", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">Earnings</TranslateText>
                                                <Box>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.commision_amount?"--.--":addCurrencyAndCommafy(detail?.commision_amount)}</TranslateText>
                                                
                                                </Box>
                                                </Box>
                                            </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column",  height:"4px", gap:"10px", background:"#EDF1F9" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:calculateWidth(detail), height:"4px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FF5449"}}></Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column", height:"40px", borderRadius:"0px 0px 8px 8px", justifyContent:"center", border:"1px solid #E5E8F0", padding:"12px",background:detail.package_status=="Accomplished"?selectPackageColor(detail, "Three"):"#FFF8F7"}}>
                                            {detail.package_status=="Accomplished"?
                                            <TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color={detail.package_status=="Accomplished"?selectPackageColor(detail, "Two"):"#DE3730"}>Ready for Withdraw</TranslateText>
                                            :<TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color="#DE3730">Activate Withdrawals with a Rs. {detail.package_remaining_amount} purchase of product</TranslateText>}
                                        </Box>
                                    </Box>
                                ))
                                }
                            </Slider>
                            {/* <Box ref={packagesRef} sx={{ position:"relative" ,display: "flex", flexDirection:{xs:"column",sm:"row"}, width:"unset", alignItems:"center",gap:"24px", 
                            overflowX:"hidden", 
                            "&::-webkit-scrollbar":{display:"none"}, scrollBehavior:"smooth",
                            "&::-webkit-scrollbar": {width: "0px",height:"5px"}, WebkitScrollbarTrackColor: 'primary' , msOverflowStyle: "none", "::-webkit-scrollbar-track":{backgroundColor: "primary"}
                            }}>

                            </Box> 
                        </Stack>
                        :
                        <Stack sx={{width:"100%"}}>
                            <Box ref={packagesRef} sx={{ display: "flex", flexDirection:{xs:"column",sm:"row"}, width:"100%", alignItems:"center",gap:"24px", overflowX:"auto", "&::-webkit-scrollbar":{display:"none"}, scrollBehavior:"smooth"
                            // "&::-webkit-scrollbar": {width: "0px",height:"5px"}, WebkitScrollbarTrackColor: 'primary' , msOverflowStyle: "none", "::-webkit-scrollbar-track":{backgroundColor: "primary"}
                            }}>
                                {packagedetails?.length>0 ? packagedetails.map((detail, index) => (
                                    <Box sx={{ display:"flex", flexDirection:"column", maxWidth:"60%",width:"100%",minWidth:"315px", height:"100%" }}>
                                        <Box sx={{ display:"flex", flexDirection:"column",width:"315px", height:"220px", borderRadius:"8px 8px 0px 0px", border:"1px solid #E5E8F0", background:"#FFFFFF", gap:"12px", justifyContent:"center" }}>
                                            <Box sx={{ display:"flex", flexDirection:"row",width:"280px", height:"24px", justifyContent:"space-between" }}>
                                                <Box sx={{ display:"flex", flexDirection:"column", width:"96px", height:"24px", borderRadius:"0px 12px 12px 0px", padding:"4px 6px 4px 6px", gap:"10px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FFEDEA" }}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color={detail.package_status=="Accomplished"?"#FFFFFF":"#FF5449"}>{detail.package_status}</TranslateText>
                                                </Box>
                                                <Tooltip title="Coming Soon" arrow>
                                                <img src={ThreeDotIcon} style={{width:"3.33px", height:"13.33px", marginTop:"4px", cursor:"pointer"}}/>
                                                </Tooltip>
                                            </Box>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"121px", gap:"10px", padding:"0px 16px 0px 16px" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"121px", gap:"8px" }}>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"100%", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">{detail.package_type} ({!detail.package_amount?"--.--":addCurrencyAndCommafy(detail.package_amount)})</TranslateText>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{userreponse?.orders_pv? 
                                                    ( parseFloat(userreponse.orders_pv[index+1]) > ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) ? 
                                                        ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) : userreponse.orders_pv[index+1] )    + "/" + ( parseInt(userreponse?.pk_info?.[index]?.price) * 0.6 ) 
                                                    : 
                                                    "--/--"
                                                }</TranslateText>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">(Exclusive of Other Charges)</TranslateText>
                                                </Box>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"100%", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">Earnings</TranslateText>
                                                <Box>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.package_amount?"--.--":addCurrencyAndCommafy(detail?.commision_amount)}</TranslateText>
                                                {/* <TranslateText sx={{ fontWeight: 400, fontSize: "14px" }} color="grey.900">{!detail.commision_amount?"--.--":calculatePV(detail)}</TranslateText> 
                                                </Box>
                                                </Box>
                                            </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column", width:"315px", height:"4px", gap:"10px", background:"#EDF1F9" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:calculateWidth(detail), height:"4px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FF5449"}}></Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column",width:"315px", height:"40px", borderRadius:"0px 0px 8px 8px", justifyContent:"center", border:"1px solid #E5E8F0", padding:"12px",background:detail.package_status=="Accomplished"?selectPackageColor(detail, "Three"):"#FFF8F7"}}>
                                            {detail.package_status=="Accomplished"?
                                            <TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color={detail.package_status=="Accomplished"?selectPackageColor(detail, "Two"):"#DE3730"}>Ready for Withdraw</TranslateText>
                                            :<TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color="#DE3730">Activate Withdrawals with a Rs. {detail.package_remaining_amount} purchase of product</TranslateText>}
                                        </Box>
                                    </Box>
                                )):package_details.map((detail, index) => (
                                    <Box sx={{ display:"flex", flexDirection:"column", width:"100%", height:"100%" }}>
                                        <Box sx={{ display:"flex", flexDirection:"column", height:"220px", borderRadius:"8px 8px 0px 0px", border:"1px solid #E5E8F0", background:"#FFFFFF", gap:"12px", justifyContent:"center" }}>
                                            <Box sx={{ display:"flex", flexDirection:"row",height:"24px", justifyContent:"space-between" }}>
                                                <Box sx={{ display:"flex", flexDirection:"column", width:"96px", height:"24px", borderRadius:"0px 12px 12px 0px", padding:"4px 6px 4px 6px", gap:"10px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FFEDEA" }}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight:"16px" }} color={detail.package_status=="Accomplished"?"#FFFFFF":"#FF5449"}>{detail.package_status}</TranslateText>
                                                </Box>
                                                <Tooltip title="Coming Soon" arrow>
                                                <img src={ThreeDotIcon} style={{width:"3.33px", height:"13.33px", marginTop:"4px", cursor:"pointer"}}/>
                                                </Tooltip>
                                            </Box>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"185px", height:"121px", gap:"10px", padding:"0px 16px 0px 16px" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:"170px", height:"121px", gap:"8px" }}>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"170px", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">{detail.package_type}</TranslateText>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.package_amount?"--.--":addCurrencyAndCommafy(detail.package_amount)}</TranslateText>
                                                </Box>
                                                <Box sx= {{ display:"flex", flexDirection:"column", width:"170px", height:"80px", gap:"0px"}}>
                                                <TranslateText sx={{ fontWeight: 400, fontSize: "16px" }} color="grey.900">Earnings</TranslateText>
                                                <Box>
                                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!detail.commision_amount?"--.--":addCurrencyAndCommafy(detail?.commision_amount)}</TranslateText>
                                                {/* <TranslateText sx={{ fontWeight: 400, fontSize: "14px" }} color="grey.900">{!detail.commision_amount?"--.--":calculatePV(detail)}</TranslateText> 
                                                </Box>
                                                </Box>
                                            </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column",  height:"4px", gap:"10px", background:"#EDF1F9" }}>
                                            <Box sx={{ display:"flex", flexDirection:"column", width:calculateWidth(detail), height:"4px", background:detail.package_status=="Accomplished"?selectPackageColor(detail, "One"):"#FF5449"}}></Box>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection:"column", height:"40px", borderRadius:"0px 0px 8px 8px", justifyContent:"center", border:"1px solid #E5E8F0", padding:"12px",background:detail.package_status=="Accomplished"?selectPackageColor(detail, "Three"):"#FFF8F7"}}>
                                            {detail.package_status=="Accomplished"?
                                            <TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color={detail.package_status=="Accomplished"?selectPackageColor(detail, "Two"):"#DE3730"}>Ready for Withdraw</TranslateText>
                                            :<TranslateText sx={{ fontWeight: 400, fontSize: "11px", textAlign:"center" }} color="#DE3730">Activate Withdrawals with a Rs. {detail.package_remaining_amount} purchase of product</TranslateText>}
                                        </Box>
                                    </Box>
                                ))}

                            </Box>
                        </Stack>
                        }
                        {isTablet || isLaptop ?<Stack>
                            <Button disabled={ isLaptop && activeSlide == 3 ? true :isXLaptop && activeSlide == 3 ? true : activeSlide == 5? true: false } sx={[ 
                                isLaptop && activeSlide == 3 ? {border:"1px solid #CBD5E1",color:"#CBD5E1"} :isXLaptop && activeSlide == 3 ? {border:"1px solid #CBD5E1",color:"#CBD5E1"} : activeSlide == 5? {border:"1px solid #CBD5E1",color:"#CBD5E1"}: {border:"1px solid #64748B",color:"#64748B"},
                                {minWidth:"36px", borderRadius:"4px",p:"8px"}]} onClick={()=>{sliderRef.current?.slickNext()}}
                                >
                                    <ChevronRight/>
                                </Button>
                        </Stack>:null}
                    </Stack>
                    </Box> */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", padding: 0, width:"100%", }}>
                        {/* <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900"> Team</TranslateText> */}
                        {/* <Box sx={{ display:"flex", flexDirection:{sm:"row",xs:"column"},  alignItems:"center",gap:"24px", overflowX:"auto", "&::-webkit-scrollbar": {width: "0px",}, scrollbarWidth: "none", msOverflowStyle: "none", "::-webkit-scrollbar-track":{backgroundColor: "transparent",}  }}>
                            <Box sx={{ display:"flex", flexDirection:"row", minWidth:"300px",height:"66px", border:"1px solid #F0F4FC", background:"#FFFFFF", gap:"24px", alignItems:"center", padding:"12px 18px 12px 18px" }}>
                                <img src={RecievedIcon} style={{ width:"32px", height:"32px" }}/>
                                <Box sx={{ display:"flex", flexDirection:"column",  height:"42px", gap:"2px" }}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">My orders</TranslateText>
                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!userreponse?.order_Count?"--":userreponse?.order_Count}</TranslateText>
                                </Box>
                            </Box>
                            <Box sx={{ display:"flex", flexDirection:"row",  minWidth:"300px",  height:"66px", border:"1px solid #F0F4FC", background:"#FFFFFF", gap:"24px", alignItems:"center", padding:"12px 18px 12px 18px" }}>
                                <img src={OrgIcon} style={{ width:"32px", height:"32px" }}/>
                                <Box sx={{ display:"flex", flexDirection:"column",  height:"42px", gap:"2px" }}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">Max Tier Level</TranslateText>
                                <Typography sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{userreponse?.level>9 ?9:userreponse?.level}/9</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display:"flex", flexDirection:"row",minWidth:"300px",  height:"66px", border:"1px solid #F0F4FC", background:"#FFFFFF", gap:"24px", alignItems:"center", padding:"12px 18px 12px 18px" }}>
                                <img src={MeetIcon} style={{ width:"32px", height:"32px" }}/>
                                <Box sx={{ display:"flex", flexDirection:"column", height:"42px", gap:"2px" }}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">Team Size</TranslateText>
                                <Typography sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!userreponse?.team_size?"--":userreponse?.team_size}</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display:"flex", flexDirection:"row",  minWidth:"300px", height:"66px", border:"1px solid #F0F4FC", background:"#FFFFFF", gap:"24px", alignItems:"center", padding:"12px 18px 12px 18px" }}>
                                <img src={WageIcon} style={{ width:"32px", height:"32px" }}/>
                                <Box sx={{ display:"flex", flexDirection:"column", height:"42px", gap:"2px" }}>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px" }} color="grey.900">Team Earnings</TranslateText>
                                <TranslateText sx={{ fontWeight: 600, fontSize: "16px" }} color="grey.900">{!userreponse?"--.--":addCurrencyAndCommafy(userreponse?.team_earnings/0.6)}</TranslateText>
                                </Box>
                            </Box>
                        </Box> */}
                    {/* <Box sx={{ display:"flex", flexDirection:"column", width:"100%",maxWidth:"100%", padding:"0px 0px 24px 0px", gap:"16px", opacity:"1", }} > */}
                    {/* <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Performance</TranslateText> */}
                    {/* <Box sx={{ display:"flex", flexDirection:{xs:"column",sm:"row"}, gap:"16px",alignItems:"center",justifyContent:'space-between'}}> */}
                    {/* <Box sx={{ display:"flex", flexDirection:"column",gap:"16px",width:{xs:"100%",sm:"50%"}, }}>
                        <Box sx={{ display:"flex", flexDirection:"column",width:"100%", border:"1px solid lightgrey", borderRadius:"8px" }}>
                            <Box sx={{ display:"flex", flexDirection:"row", width:"100%", height:"100px",justifyContent:"space-between", padding:"16px", alignItems:"center", borderBottom:"1px solid lightgrey" }} >
                                <Box sx={{ display:"flex", flexDirection:"row", width:"100%", gap:"8px",alignItems:"center",justifyContent:"space-between" }}>
                                <Box sx={{ display:"flex", flexDirection:"row",  height:"19px", gap:"8px" }}>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px", lineHeight:"16px" }} color="grey.900">Top Performer</TranslateText>
                                </Box>
                                <Select defaultValue={0} sx={{height:"40px"}} onChange={(e)=>teamPerformanceValues(res.team_growth,e.target.value)}>
                                    {teamPerformance?.map((item,index)=><MenuItem value={index}>{item.name}</MenuItem>)}
                                
    

                                </Select>
                                </Box>
                            </Box>
                            {performanceChart?
                            <Line data={performanceChart} options={chartOptions} style={{ width:"100%", height:"250px"}}/>:<Line data={withdraw_data} options={chartOptions} style={{ width:"100%", height:"250px"}}/>}
                        </Box>
                    </Box> */}
                    {/* <Box sx={{ display:"flex", flexDirection:"column", gap:"16px",width:{xs:"100%",sm:"50%"}, }}>
                        <Box sx={{ display:"flex", flexDirection:"column", border:"1px solid lightgrey", borderRadius:"8px" }}>
                            <Box sx={{ display:"flex", flexDirection:"row", width:"100%", height:"100px",justifyContent:"space-between", padding:"16px", alignItems:"center", borderBottom:"1px solid lightgrey" }} >
                                <Box sx={{ display:"flex", flexDirection:"column", width:"100%", gap:"8px" }}>
                                <Box sx={{ display:"flex", flexDirection:"row", width:"80%", height:"19px", gap:"8px" }}>
                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px", lineHeight:"16px" }} color="grey.900">Team Growth</TranslateText>
                                
                                
                                </Box>
                                </Box>
                            </Box>
                            {teamChart?
                            <Line data={teamChart} options={chartOptions} style={{ width:"100%", height:"250px"}}/>:<Line data={withdraw_data} options={chartOptions} style={{ width:"100%", height:"250px"}}/>}
                        </Box>
                    </Box>
                    </Box>
                    
                    </Box> */}
                   {/* {commissions.length>0 &&  <Box>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Earnings History</TranslateText>
                    {commissionChart&&
                        <Bar data={commissionChart} options={options} style={{ width:"100%", height:"250px"}}/>}
                    </Box>} */}
                    {/* </Tooltip> */}
                    <Box sx={{ display:"flex", flexDirection:"column", maxWidth:"100%",  padding:"0px 0px 24px 0px", gap:"16px", opacity:"1", }} >
                    <Box sx={{display:"flex",flexDirection:"column",gap:"16px",alignItems:"stretch"}} >
                        {/* Breadcrumb Navigation */}
                        {/* {treeBoard.length > 1 && (
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexWrap: "wrap",
                                p: 2,
                                backgroundColor: "#f8f9fa",
                                borderRadius: 2,
                                border: "1px solid #e9ecef"
                            }}>
                                {treeBoard.map((item, index) => (
                                    <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        {index > 0 && <Typography sx={{ color: "#6c757d" }}>›</Typography>}
                                        <Button
                                            variant={index === treeBoard.length - 1 ? "contained" : "text"}
                                            size="small"
                                            onClick={() => backWard(index, item?.member?.id)}
                                            sx={{
                                                textTransform: "none",
                                                minWidth: "auto",
                                                px: 1
                                            }}
                                        >
                                            {capitalize(item?.member?.first_name || "")} {capitalize(item?.member?.last_name || "")}
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                        )}

                        {/* Team Board - Toggle between simple tree and organizational chart 
                        
                            <Box sx={{ mb: 2, display: 'flex', gap: 1, justifyContent: 'center' }}>
                                <Button
                                    variant={useSimpleTree ? "contained" : "outlined"}
                                    size="small"
                                    onClick={() => setUseSimpleTree(true)}
                                >
                                    Simple Tree
                                </Button>
                                <Button
                                    variant={!useSimpleTree ? "contained" : "outlined"}
                                    size="small"
                                    onClick={() => setUseSimpleTree(false)}
                                >
                                    Org Chart
                                </Button>
                            </Box>

                            {useSimpleTree ? (
                                // Simple Tree Implementation (working)
                                treeBoard.length > 0 && treeBoard[treeBoard.length - 1] ? (
                                    <TreeNode
                                        member={treeBoard[treeBoard.length - 1].member}
                                        level={treeBoard.length - 1}
                                    />
                                ) : (
                                    <Box sx={{
                                        textAlign: "center",
                                        py: 4,
                                        color: "#6c757d"
                                    }}>
                                        <AccountTreeIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
                                        <Typography>No team members to display</Typography>
                                    </Box>
                                )
                            ) : ( 
                                // Organizational Chart (new implementation)
                               
                            // )}*/}
	                        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: "12px" }}>
	                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
	                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Team Metrics</TranslateText>
	                            </Box>
                            {isTreeLoading ? (
                                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                    <Skeleton variant="rounded" height={92} sx={{ flex: "1 1 220px", minWidth: { xs: "100%", sm: 180 } }} />
                                    <Skeleton variant="rounded" height={92} sx={{ flex: "1 1 220px", minWidth: { xs: "100%", sm: 180 } }} />
                                    <Skeleton variant="rounded" height={92} sx={{ flex: "1 1 220px", minWidth: { xs: "100%", sm: 180 } }} />
                                </Box>
                            ) : treeLoadError ? (
                                <Box sx={{ p: 2, borderRadius: "8px", bgcolor: "#FEF2F2" }}>
                                    <Typography sx={{ fontSize: "14px", color: "#B91C1C" }}>
                                        {treeLoadError}
                                    </Typography>
                                </Box>
                            ) : (
                            <Box sx={{
                                display: "flex",
                                gap: 2,
                                flexWrap: "wrap",
                                justifyContent: "stretch",
                                alignItems: "stretch",
                            }}>
                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 220px",
                                    minWidth: { xs: "100%", sm: 180 },
                                    textAlign: "center",
                                    backgroundColor: "#e3f2fd",
                                    boxShadow: "none",
                                }}>
                                    <Typography variant="h6" sx={{ color: "#1976d2", fontWeight: "bold" }}>
                                        {resolvedTotalMembers}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#1976d2" }}>
                                        Total Members
                                    </Typography>
                                </Paper>

                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 220px",
                                    minWidth: { xs: "100%", sm: 180 },
                                    textAlign: "center",
                                    backgroundColor: "#f3e5f5",
                                    boxShadow: "none",
                                }}>
                                    <Typography variant="h6" sx={{ color: "#7b1fa2", fontWeight: "bold" }}>
                                        {resolvedTeamLevel}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#7b1fa2" }}>
                                        Current Level
                                    </Typography>
                                </Paper>

                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 220px",
                                    minWidth: { xs: "100%", sm: 180 },
                                    textAlign: "center",
                                    backgroundColor: "#e8f5e8",
                                    boxShadow: "none",
                                }}>
                                    <Typography variant="h6" sx={{ color: "#388e3c", fontWeight: "bold" }}>
                                        {resolvedDirectMembers}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#388e3c" }}>
                                        Direct Members
	                                    </Typography>
	                                </Paper>
	                            </Box>
	                            )}
	                        </Paper>

	                        {showTeamInsights && (
	                        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: "12px" }}>
	                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
	                                <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Team Insights</TranslateText>
	                            </Box>
	                            {hasInsightsData ? (
	                            <>
	                            <Box sx={{
	                                display: "flex",
	                                gap: 2,
                                flexWrap: "wrap",
                                mb: 2.5,
                            }}>
                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 160px",
                                    minWidth: { xs: "100%", sm: 160 },
                                    backgroundColor: "#F8FAFC",
                                    boxShadow: "none",
                                }}>
                                    <Typography sx={{ fontSize: "13px", color: "#64748B", mb: 0.5 }}>
                                        This Week
                                    </Typography>
                                    <Typography sx={{ fontSize: "24px", fontWeight: 700, color: "#0F172A" }}>
                                        {teamInsights?.totalThisWeek ?? 0}
                                    </Typography>
                                </Paper>

                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 160px",
                                    minWidth: { xs: "100%", sm: 160 },
                                    backgroundColor: "#F8FAFC",
                                    boxShadow: "none",
                                }}>
                                    <Typography sx={{ fontSize: "13px", color: "#64748B", mb: 0.5 }}>
                                        Best Day
                                    </Typography>
                                    <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#0F172A" }}>
                                        {teamInsights?.bestDayLabel ?? "--"}
                                    </Typography>
                                    <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                                        {teamInsights?.bestDayCount ?? 0} signups
                                    </Typography>
                                </Paper>

                                <Paper sx={{
                                    p: 2,
                                    flex: "1 1 160px",
                                    minWidth: { xs: "100%", sm: 160 },
                                    backgroundColor: "#F8FAFC",
                                    boxShadow: "none",
                                }}>
                                    <Typography sx={{ fontSize: "13px", color: "#64748B", mb: 0.5 }}>
                                        Avg / Day
                                    </Typography>
                                    <Typography sx={{ fontSize: "24px", fontWeight: 700, color: "#0F172A" }}>
                                        {teamInsights?.averagePerDay ?? "0.0"}
                                    </Typography>
                                </Paper>
	                            </Box>

	                            <Box sx={{
	                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) minmax(0, 1fr)" },
                                gap: 2,
                            }}>
                                <Box sx={{
                                    p: { xs: 1.5, sm: 2 },
                                    borderRadius: "12px",
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #E2E8F0",
                                }}>
                                    <Box sx={{ mb: 1.5 }}>
                                        <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#0F172A" }}>
                                            Daily Signups
                                        </Typography>
                                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                                            Last 7 days
                                        </Typography>
                                    </Box>
                                    <Box sx={{ height: { xs: 220, sm: 240 } }}>
                                        <Bar data={teamInsights?.signupBar || withdraw_data} options={insightChartOptions} />
                                    </Box>
                                </Box>

                                <Box sx={{
                                    p: { xs: 1.5, sm: 2 },
                                    borderRadius: "12px",
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #E2E8F0",
                                }}>
                                    <Box sx={{ mb: 1.5 }}>
                                        <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#0F172A" }}>
                                            Growth Trend
                                        </Typography>
                                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                                            Cumulative signups this week
                                        </Typography>
                                    </Box>
                                    <Box sx={{ height: { xs: 220, sm: 240 } }}>
	                                        <Line data={teamInsights?.growthLine || lineChartData} options={insightLineOptions} />
	                                    </Box>
	                                </Box>
	                            </Box>
	                            </>
	                            ) : (
	                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
	                                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
	                                        <Skeleton variant="rounded" height={88} sx={{ flex: "1 1 160px", minWidth: { xs: "100%", sm: 160 } }} />
	                                        <Skeleton variant="rounded" height={88} sx={{ flex: "1 1 160px", minWidth: { xs: "100%", sm: 160 } }} />
	                                        <Skeleton variant="rounded" height={88} sx={{ flex: "1 1 160px", minWidth: { xs: "100%", sm: 160 } }} />
	                                    </Box>
	                                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) minmax(0, 1fr)" }, gap: 2 }}>
	                                        <Skeleton variant="rounded" height={280} />
	                                        <Skeleton variant="rounded" height={280} />
	                                    </Box>
	                                </Box>
	                            )}
	                        </Paper>
	                        )}

	                        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: "12px" }}>
                            <Box sx={{display:"flex", justifyContent:"flex-start", alignItems: "center", mb: 2}}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <AccountTreeIcon sx={{ color: "#00C2FF" }} />
                                    <TranslateText sx={{ fontWeight: 700, fontSize: "16px" }} color="grey.900">Team Structure</TranslateText>
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', minHeight: '600px', py: 1 }}>
                            {treeLoadError ? (
                                <Box sx={{ p: 2, borderRadius: "8px", bgcolor: "#FEF2F2" }}>
                                    <Typography sx={{ fontSize: "14px", color: "#B91C1C" }}>
                                        {treeLoadError}
                                    </Typography>
                                </Box>
                            ) : (
                            <SimpleOrgChart
                                    teamTree={[]}
                                    treeBoard={treeBoard}
                                    onNextTree={() => {}}
                                    // onBackward={backWard}
                                    name={first_name + ' ' + last_name}
                                    onFetchChildren={fetchChildrenData}
                                    onMetricsChange={setTreeMetrics}
                                    isLoading={isTreeLoading}
                                    isExpandedView={false}
                                />
                            )}
                        </Box>
                        </Paper>

                        {/* <Grid container sx={{display:"flex",justifyContent:"center",alignSelf:"center",}}> */}
                        {/* {team_member?.map(item=> {
                            // console.log(item)
                        return(<Grid md={4} xs={12} sx={{padding:"10px",cursor:"pointer",display:"flex",justifyContent:"start"}}  item  onClick={()=>third_stage_member(item.member?.id)}>
                                 <Box sx={{display:"flex",gap:"10px",alignItems:"center"}}>
                       
                        
                                    {item.imageurl ? <img src={item.imageurl} style = {{width:"72px",height:"72px",objectFit:"cover",background:"#CBD5E1",border:"none", borderRadius:"36px"}} alt='Profile'/>:<Avatar {...teamStringAvatar(capitalize(item.member?.first_name)+" "+capitalize(item.member?.first_name))}  />}
                                    <Box>
                                    
                                    {/* <TranslateText sx={{fontSize:"14px",}} >{capitalize(item.member?.first_name)+" "+capitalize(item.member?.last_name)} {item.member?.username? `(${item.member?.username})`:"" } </TranslateText>
                                    {/* <TranslateText sx={{fontSize:"14px",color:"#6F7883"}}> User Name: <span style={{color:"#000"}}>{item.member?.username&&}</span> </TranslateText> 
                                    <Box sx={{display:"flex"}}><TranslateText sx={{fontSize:"14px",color:"#6F7883"}}> Level: </TranslateText> <Typography sx={{fontSize:"14px",color:"#6F7883"}}>{treeBoard?.length}</Typography></Box>
                                    <Box sx={{display:"flex"}}><TranslateText  sx={{fontSize:"14px",color:"#6F7883"}}>Members:</TranslateText> <Typography sx={{fontSize:"14px",color:"#6F7883"}}>{item?.team_count}</Typography></Box>
                                    {secondLevel&&
                                    <TranslateText sx={{fontSize:"14px",color:"#6F7883"}}>Mobile No: <span style={{color:"#000"}}>{item?.member?.mobileno?item?.member?.mobileno:"-"}</span></TranslateText>}
                                    </Box>


                                </Box>
                            </Grid>)}
                        )} */}

                           


                        {/* </Grid> */}
                    </Box>
                    </Box>
                    
                    </Box>
                </Box>
                )}
            </Box>
        
        </Box>
    )
}
export default Dashboard
